<template>
  <div>
    <dropdown class="position-static d-none d-lg-block">
      <template v-slot:trigger="props">
        <square-button :to="''"
                       :color="'#fff'"
                       :is-active="props.isOpen"
                       :is-dark="false">
          <cart-icon :color="'#fff'" :items-count="basketitemsCount"/>
          <span class="label">Košík</span>
        </square-button>
      </template>
      <template v-slot:body>
        <cart-dropdown :basketitems="basketitems"></cart-dropdown>
      </template>
    </dropdown>
    <square-button 
        class="d-lg-none"
        :to="''"
        :color="'#fff'"
        :is-dark="false"
        :on-click="handleCartClick">
      <cart-icon :color="'#fff'" :items-count="basketitemsCount"/>
      <span class="label">Košík</span>
    </square-button>
  </div>
</template>

<script>
import SquareButton from "@/common/components/SquareButton"
import CartIcon from "@/common/components/CartIcon"
import Dropdown from "@/common/components/dropdown"
import CartDropdown from "@/common/components/cart/CartDropdown"

export default {
  components: {SquareButton, CartIcon, Dropdown, CartDropdown},
  computed: {
    basketitemsCount() {
      return this.$store.getters['cartModule/getBasketItemsCount']
    },
    basketitems() {
      return this.$store.getters['cartModule/getBasketItems']
    }
  },
  methods: {
    handleCartClick(){
      window.location.href = "/cart/";
    }
  }
  
}
</script>

<style lang="scss" scoped>
.square-button {
  width: auto;
}

.layoutHeaderButton__badge {
  left: 22px;
  right: auto;
}

.label {
  margin: 0;
  color: #fff;
  position: relative;
  bottom: 0;
  padding: 0;
  padding-left: 20px;
  padding-right: 5px;
  vertical-align: bottom;
  padding-top: 5px;
}
</style>